import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { CMSContext } from 'context/AppContext';

const MoDialog = ({children, open, onClose, ...other}) => {
    let CmsContext = React.useContext(CMSContext);
    const [cms] = React.useState(CmsContext);

    return (
        <Dialog open={open} onClose={onClose} {...other}>
            {React.cloneElement(children, {...{modalsCms: cms.modals}})}
        </Dialog>
    );
}
 
export default MoDialog;